import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IArticleListResponse} from "../actions/fetch_article_list";

export const fetchArticlesResults = (phrase: string) => {
    const url = appendQueryString(apiV2ListLink.article.list(Scenario.ARTICLE_LIST), {phrase});

    return getRequest({}, url).then((json: IArticleListResponse) => {
        return json;
    });
};
